<template>
	<a-modal width="55%" title="对接列表" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" :footer="null" @ok="onSubmit" @cancel="onClose">
		<a-table :columns="columns" :data-source="form.list" bordered :pagination="false">
			<template #headShot="{ record }">
				<div style="position: relative; width:35px; height:35px; margin: 3px 3px; overflow: hidden;">
					<img-upload style="position: absolute; top:-35px; left:-35px" v-model:value="record.headShot" :showList="true"
						disabled />
				</div>
			</template>
			<template #name="{ record }">
				<a @click="onDetail(record)">{{ record.name }}</a>
			</template>
			<template #dateBirth="{ text }">
				<span>{{ text && text.split(' ')[0] }}</span>
			</template>
			<template #educationBackground="{ text }">
				<dict-render :dict-obj="dictObjs['education_background']" :text="text" v-if="text"></dict-render>
			</template>
			<template #researchArea="{ text }">
				<dict-render :dict-obj="dictObjs['research_field']" :text="text" v-if="text"></dict-render>
			</template>
			<template #approveType="{ text }">
				<dict-render :dict-obj="dictObjs['expert_type']" :text="text" v-if="text"></dict-render>
			</template>
		</a-table>
	</a-modal>
</template>
<script>
import { formMixin, dictMixin } from "@/mixins";
import DictRender from "@/components/other/DictRender";

const columns = [
	{ title: "用户头像", dataIndex: "headShot", key: "headShot", slots: { customRender: "headShot" } },
	{ title: "技术经理人姓名", dataIndex: "name", key: "name", slots: { customRender: "name" } },
	{
		title: "性别", dataIndex: "sex", key: "sex", customRender: (text) => {
			if (text.text == '0') {
				return <span>男</span>
			} else {
				return <span>女</span>
			}
		}
	},
	{ title: "手机号码", dataIndex: "phoneNumber", key: "phoneNumber" },
	{ title: "学历", dataIndex: "educationBackground", key: "educationBackground", slots: { customRender: "educationBackground" } },
	{ title: "研究领域", dataIndex: "researchArea", key: "researchArea", slots: { customRender: "researchArea" } },
	{ title: "工作单位", dataIndex: "unitWork", key: "unitWork" },
];
export default {
	name: "DetailModal",
	components: {
		DictRender
	},

	mixins: [formMixin, dictMixin],
	data() {
		return {
			columns,
			dictNames: "demand_type,belong_techField,projectStage,demand_priority,demand_value,cooperation_methods,education_background,research_field,expert_type",
			form: {
				parentId: null,
			},
		}
	},
}
</script>
<style scoped lang="less">
.pingguInfo {
	-webkit-box-flex: 1;
	-ms-flex: auto;
	flex: auto;
	overflow: hidden;
	color: rgba(0, 0, 0, 0.85);
	font-weight: bold;
	font-size: 16px;
	line-height: 1.5715;
	white-space: nowrap;
	text-overflow: ellipsis;
	margin-bottom: 15px;
}
</style>
